import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// API
import ProcesosApi from "api/procesosApi";
import DocumentoBien from "./documentoBien";

const DocumentosBienes = ({ procesoId, identificador, setError }) => {
  const [bienes, setBienes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBienes = async () => {
      try {
        const response = await ProcesosApi.obtenerBienesProceso(procesoId);
        setBienes(response.data?.bienes || []);
      } catch (error) {
        console.error("Error obteniendo bienes:", error);
        setError(obtenerMensajeError(error, "Error al cargar los bienes del Proceso"));
      } finally {
        setLoading(false);
      }
    };

    if (procesoId) {
      fetchBienes();
    }
  }, [procesoId, setError]);

  if (loading) {
    return <Typography>Cargando documentos de bienes...</Typography>;
  }

  if (bienes.length === 0) {
    return null;
  }

  const bienesPorTipo = bienes.reduce((acc, bien) => {
    const tipo = bien.tipo_bien;
    if (!acc[tipo]) acc[tipo] = [];
    acc[tipo].push(bien);
    return acc;
  }, {});

  return (
    <SuiBox>
      {Object.entries(bienesPorTipo).map(([tipo, bienesTipo]) => (
        <SuiBox key={tipo}>
          <Divider>
            <SuiTypography variant="h5" fontWeight="medium">
              {tipo === "INMUEBLE" ? "Bienes Inmuebles" : "Bienes Muebles"}
            </SuiTypography>
          </Divider>
          <Grid container spacing={3} p={1}>
            {bienesTipo.map((bien) => (
              <Grid item xs={12} md={6} key={bien.id}>
                <DocumentoBien
                  bien={bien}
                  procesoId={procesoId}
                  identificador={identificador}
                  setError={setError}
                />
              </Grid>
            ))}
          </Grid>
        </SuiBox>
      ))}
    </SuiBox>
  );
};

DocumentosBienes.propTypes = {
  procesoId: PropTypes.number.isRequired,
  identificador: PropTypes.string,
  setError: PropTypes.func.isRequired,
};

export default DocumentosBienes;
